import React, { useCallback } from 'react';
import { inputs, inputsV2 } from '@ecosystem/newron-design-system';
import { ConfigItemElementProps } from './types';
import { DataTypeControlConfigItem } from '../types';
import { DataType } from '../../components/types';

const { FormControl } = inputs;
const { Select } = inputsV2;

const dataTypeOptions: Array<{ value: DataType; label: string }> = [
  { value: 'live', label: 'Live' },
  { value: 'static', label: 'Static' },
];

function DataTypeControlElement({
  configItem: { key, value, disabled },
  onChange,
}: ConfigItemElementProps<DataTypeControlConfigItem>) {
  const handleChange = useCallback(
    (value: DataType) => {
      const entity = dataTypeOptions.find(o => o.value === value);
      onChange(key, entity?.value ?? 'live');
    },
    [key, onChange]
  );

  return (
    <FormControl
      name="viewDataType"
      label="Data type"
      infoMessage="Be aware that static data will expire at some point."
      labelTooltip={
        <>
          <strong>Live data</strong> updates weekly or monthly. <strong>Static data</strong> is a snapshot of the
          selected timeframe.
        </>
      }
    >
      <Select
        value={value}
        options={dataTypeOptions}
        hasSameValueOnClick={value === 'live'}
        onChange={handleChange}
        disabled={disabled}
      />
    </FormControl>
  );
}

export { DataTypeControlElement };
